import { PrintType } from '@/types';
import { possiblePrintTypesForSelectedConfiguration } from '@/redux/draft/getters/possiblePrintTypesForSelectedConfiguration';
import { StoreState } from '@/redux/types';

export const getCanSwitchPrintType = (printType: PrintType) => (state: StoreState) => {
  const possiblePrintTypes = possiblePrintTypesForSelectedConfiguration(state);
  const possiblePrintTypesCount = possiblePrintTypes.length;

  return (
    // more than one print type available - default case
    possiblePrintTypesCount > 1 ||
    // only one print type available but it's not the current one - print type was replaced
    (possiblePrintTypesCount === 1 && !possiblePrintTypes.some(({ id }) => id === printType.id))
  );
};
